import type { ToolOperation } from '@saas-pages/shared/public/runtime'

export interface OperationRef {
  current: ToolOperation | null
}

export interface VersionRef {
  current: number
}

export interface OperationGenerationRef {
  current: number
}

export function beginReplacement(versionRef: VersionRef): number {
  versionRef.current += 1
  return versionRef.current
}

export function beginReplacementOperation(
  operationRef: OperationRef,
  operationGenerationRef: OperationGenerationRef,
  versionRef: VersionRef,
  version: number,
  startOperation: () => ToolOperation,
): boolean {
  if (version !== versionRef.current) return false
  operationRef.current = startOperation()
  operationGenerationRef.current = version
  return true
}

export function beginSamplingOperation(
  operationRef: OperationRef,
  operationGenerationRef: OperationGenerationRef,
  generation: number,
  startOperation: () => ToolOperation,
): boolean {
  if (operationRef.current) return operationGenerationRef.current === generation
  operationRef.current = startOperation()
  operationGenerationRef.current = generation
  return true
}

/**
 * A rejected newer replacement can restore an older committed preview while a
 * now-superseded replacement operation is still active. Drop only that
 * foreign operation so sampling the restored preview can start its own
 * generation-owned operation.
 */
export function discardSupersededOperation(
  operationRef: OperationRef,
  operationGenerationRef: OperationGenerationRef,
  committedGeneration: number,
): void {
  if (operationGenerationRef.current === committedGeneration) return
  operationRef.current = null
  operationGenerationRef.current = 0
}

export function finishProcessingFailure(
  operationRef: OperationRef,
  operationGenerationRef: OperationGenerationRef,
  version: number,
): boolean {
  if (operationGenerationRef.current !== version || !operationRef.current) return false
  operationRef.current.error('processing_failed')
  operationRef.current = null
  operationGenerationRef.current = 0
  return true
}
